import { render, staticRenderFns } from "./DeferralQuery.vue?vue&type=template&id=0751977d&scoped=true"
import script from "./DeferralQuery.vue?vue&type=script&lang=js"
export * from "./DeferralQuery.vue?vue&type=script&lang=js"
import style0 from "./DeferralQuery.vue?vue&type=style&index=0&id=0751977d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0751977d",
  null
  
)

export default component.exports